const categoryData = {
  apparel: {
    slug: 'apparel',
    title: 'Apparel & Fashion',
    shortDescription: 'Garments, fashion wear and private label manufacturing from India.',
    heroDescription: 'Connect with Indian apparel manufacturers for womenswear, menswear, kidswear, uniforms, ethnic wear and private label production.',
    image: 'https://images.unsplash.com/photo-1695586648360-426a59e83d90?auto=format&fit=crop&w=800&q=80',
    subcategories: [
      "Women's Wear",
      "Men's Wear",
      'Kidswear',
      'Uniforms',
      'Private Label',
      'Ethnic & Fusion Wear',
    ],
    whatBuyersRequest: [
      'Custom designs from tech packs or reference samples',
      'Fabric and trim sourcing with production',
      'Private label and white label manufacturing',
      'Small and large order quantities',
      'Specific compliance or certification requirements',
    ],
    overview: 'India is one of the world\'s largest garment manufacturing hubs, offering a wide range of apparel categories across knit, woven and specialty fabrics. Taiga Sourcing helps international buyers connect with suitable Indian apparel manufacturers and coordinates the sourcing process from sampling to shipment.',
    seo: {
      title: 'Apparel & Fashion Sourcing from India | Taiga Sourcing',
      description: 'Source garments, fashion wear and private label apparel from Indian manufacturers. Women\'s wear, men\'s wear, kidswear, uniforms and ethnic wear.',
      keywords: 'apparel sourcing India, garment sourcing India, fashion manufacturing India, private label India',
    },
  },
  tiles: {
    slug: 'tiles',
    title: 'Tiles & Surfaces',
    shortDescription: 'Ceramic, porcelain, vitrified tiles and surface solutions from India.',
    heroDescription: 'Source ceramic, porcelain, vitrified and large format tiles from Indian manufacturers for residential, commercial and project requirements.',
    image: 'https://images.pexels.com/photos/11285332/pexels-photo-11285332.png?auto=compress&cs=tinysrgb&w=800',
    subcategories: [
      'Ceramic Tiles',
      'Porcelain Tiles',
      'Vitrified Tiles',
      'Wall Tiles',
      'Floor Tiles',
      'Large Format Tiles',
      'Slabs',
    ],
    whatBuyersRequest: [
      'Specific tile sizes, finishes and patterns',
      'Custom printing and design development',
      'Full container load (FCL) shipments',
      'Project-specific requirements and specifications',
      'Samples before bulk production',
    ],
    overview: 'India\'s tile manufacturing sector, particularly in Gujarat, is among the largest globally. Taiga Sourcing connects buyers with Indian tile manufacturers and manages the sourcing process, helping international buyers find suitable products at competitive prices.',
    seo: {
      title: 'Tiles & Surfaces Sourcing from India | Taiga Sourcing',
      description: 'Source ceramic, porcelain, vitrified and large format tiles from Indian manufacturers. Wall tiles, floor tiles, slabs and custom surfaces.',
      keywords: 'tile sourcing India, ceramic tiles India, porcelain tiles India, vitrified tiles India',
    },
  },
  bathware: {
    slug: 'bathware',
    title: 'Bathware & Sanitaryware',
    shortDescription: 'Wash basins, toilets, faucets, showers and bathroom accessories from India.',
    heroDescription: 'Source sanitaryware, bathroom fittings and accessories from Indian manufacturers for residential, hospitality and commercial projects.',
    image: 'https://images.pexels.com/photos/7031566/pexels-photo-7031566.jpeg?auto=compress&cs=tinysrgb&w=800',
    subcategories: [
      'Wash Basins',
      'Toilets',
      'Faucets',
      'Showers',
      'Bathroom Accessories',
      'Bathroom Solutions',
    ],
    whatBuyersRequest: [
      'Specific product designs and finishes',
      'OEM and private label requirements',
      'Project-based bulk requirements',
      'Custom designs and specifications',
      'Quality certifications and compliance',
    ],
    overview: 'India has a strong sanitaryware manufacturing base, producing a wide range of bathroom products for domestic and international markets. Taiga Sourcing helps buyers identify suitable manufacturers and coordinates the sourcing journey from product selection to shipment.',
    seo: {
      title: 'Bathware & Sanitaryware Sourcing from India | Taiga Sourcing',
      description: 'Source wash basins, toilets, faucets, showers and bathroom accessories from Indian manufacturers. Sanitaryware for residential and hospitality projects.',
      keywords: 'bathware sourcing India, sanitaryware India, bathroom fittings India, wash basins India',
    },
  },
  'home-decor': {
    slug: 'home-decor',
    title: 'Home & Decor',
    shortDescription: 'Kitchenware, tableware, home decor and lifestyle products from India.',
    heroDescription: 'Source home decor, kitchenware, tableware and lifestyle products from Indian manufacturers and artisan producers.',
    image: 'https://images.unsplash.com/photo-1784653549271-d82659bf0792?auto=format&fit=crop&w=800&q=80',
    subcategories: [
      'Home Decor',
      'Kitchenware',
      'Tableware',
      'Lifestyle Products',
      'Decorative Products',
    ],
    whatBuyersRequest: [
      'Custom product designs and finishes',
      'Material-specific sourcing (wood, metal, ceramic, glass)',
      'Private label and custom branding',
      'Small batch and bulk production',
      'Eco-friendly and sustainable options',
    ],
    overview: 'India offers a diverse range of home and lifestyle products, combining traditional craftsmanship with modern design. Taiga Sourcing connects international buyers with suitable manufacturers and artisan producers across India.',
    seo: {
      title: 'Home & Decor Sourcing from India | Taiga Sourcing',
      description: 'Source home decor, kitchenware, tableware and lifestyle products from Indian manufacturers. Custom designs and artisan products.',
      keywords: 'home decor sourcing India, kitchenware India, tableware India, lifestyle products India',
    },
  },
  furniture: {
    slug: 'furniture',
    title: 'Furniture',
    shortDescription: 'Wooden, metal, hospitality and outdoor furniture from India.',
    heroDescription: 'Connect with Indian furniture manufacturers for wooden, metal, hospitality and outdoor furniture production.',
    image: 'https://images.unsplash.com/photo-1690489965043-ec15758cce71?auto=format&fit=crop&w=800&q=80',
    subcategories: [
      'Wooden Furniture',
      'Metal Furniture',
      'Hospitality Furniture',
      'Outdoor Furniture',
    ],
    whatBuyersRequest: [
      'Custom designs from drawings or reference images',
      'Material-specific requirements (solid wood, engineered wood, metal)',
      'Hospitality and project-based bulk orders',
      'Finishing and upholstery specifications',
      'Packaging requirements for safe shipping',
    ],
    overview: 'India\'s furniture manufacturing sector offers a wide range of products in wood, metal and mixed materials. Taiga Sourcing helps international buyers identify suitable furniture manufacturers and coordinates the sourcing process from design to delivery.',
    seo: {
      title: 'Furniture Sourcing from India | Taiga Sourcing',
      description: 'Source wooden, metal, hospitality and outdoor furniture from Indian manufacturers. Custom designs and project-based orders.',
      keywords: 'furniture sourcing India, wooden furniture India, hospitality furniture India, outdoor furniture India',
    },
  },
  textiles: {
    slug: 'textiles',
    title: 'Textiles & Made-Ups',
    shortDescription: 'Home textiles, hospitality textiles and textile made-ups from India.',
    heroDescription: 'Source home textiles, bed linen, towels, hospitality textiles and made-up products from Indian manufacturers.',
    image: 'https://images.unsplash.com/photo-1534639077088-d702bcf685e7?auto=format&fit=crop&w=800&q=80',
    subcategories: [
      'Home Textiles',
      'Made-ups',
      'Hospitality Textiles',
      'Textile Products',
    ],
    whatBuyersRequest: [
      'Specific fabric compositions and GSM',
      'Custom sizes, patterns and designs',
      'Hospitality-grade specifications',
      'Compliance with international textile standards',
      'Bulk and repeat order requirements',
    ],
    overview: 'India is a major global supplier of home textiles and made-up products, with strong manufacturing clusters across the country. Taiga Sourcing connects international buyers with suitable textile manufacturers for a wide range of products.',
    seo: {
      title: 'Textiles & Made-Ups Sourcing from India | Taiga Sourcing',
      description: 'Source home textiles, bed linen, towels and hospitality textiles from Indian manufacturers. Custom sizes and bulk orders.',
      keywords: 'textile sourcing India, home textiles India, hospitality textiles India, made-ups India',
    },
  },
  handicrafts: {
    slug: 'handicrafts',
    title: 'Handicrafts',
    shortDescription: 'Indian handicrafts, artisan products and handmade collections.',
    heroDescription: 'Source Indian handicrafts, artisan products and handmade collections from skilled craftspeople across India.',
    image: 'https://images.unsplash.com/photo-1721508490084-1b1de5b230d4?auto=format&fit=crop&w=800&q=80',
    subcategories: [
      'Indian Handicrafts',
      'Artisan Products',
      'Decorative Products',
      'Handmade Collections',
    ],
    whatBuyersRequest: [
      'Region-specific craft styles and techniques',
      'Custom designs using traditional methods',
      'Small batch artisan production',
      'Fair trade and ethical sourcing options',
      'Mixed material and multi-craft collections',
    ],
    overview: 'India\'s handicraft sector offers an incredibly diverse range of products, from traditional pottery and metalwork to contemporary handmade designs. Taiga Sourcing helps international buyers discover and source unique handcrafted products from across India.',
    seo: {
      title: 'Handicrafts Sourcing from India | Taiga Sourcing',
      description: 'Source Indian handicrafts, artisan products and handmade collections. Traditional crafts and contemporary handmade designs.',
      keywords: 'handicrafts sourcing India, artisan products India, handmade India, Indian crafts',
    },
  },
  packaging: {
    slug: 'packaging',
    title: 'Packaging',
    shortDescription: 'Retail packaging, garment packaging, boxes, bags and custom solutions.',
    heroDescription: 'Source retail packaging, product boxes, bags and custom packaging solutions from Indian manufacturers.',
    image: 'https://images.unsplash.com/photo-1760804876166-aae5861ec7c1?auto=format&fit=crop&w=800&q=80',
    subcategories: [
      'Retail Packaging',
      'Garment Packaging',
      'Boxes',
      'Bags',
      'Custom Packaging',
    ],
    whatBuyersRequest: [
      'Custom branding and design printing',
      'Specific materials (corrugated, rigid, flexible)',
      'Eco-friendly and sustainable packaging options',
      'High-volume production requirements',
      'Packaging with product bundling',
    ],
    overview: 'India\'s packaging industry offers a comprehensive range of solutions for retail, industrial and export needs. Taiga Sourcing helps buyers find suitable packaging manufacturers and coordinates production to meet specific requirements.',
    seo: {
      title: 'Packaging Sourcing from India | Taiga Sourcing',
      description: 'Source retail packaging, boxes, bags and custom packaging solutions from Indian manufacturers. Eco-friendly and branded options.',
      keywords: 'packaging sourcing India, retail packaging India, custom packaging India, boxes bags India',
    },
  },
  electrical: {
    slug: 'electrical',
    title: 'Electrical',
    shortDescription: 'Electrical components, switchgear, wiring, panels and industrial electrical products from India.',
    heroDescription: 'Source electrical components, switchgear, panels, wiring accessories and industrial electrical products from Indian manufacturers.',
    image: 'https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?auto=format&fit=crop&w=800&q=80',
    subcategories: [
      'Switchgear',
      'Wiring Accessories',
      'Control Panels',
      'Lighting Products',
      'Cables & Wires',
      'Industrial Electrical',
    ],
    whatBuyersRequest: [
      'Specific product certifications and compliance standards',
      'OEM and private label manufacturing',
      'Bulk industrial and project-based requirements',
      'Custom panel design and assembly',
      'Export-grade packaging and labelling',
    ],
    overview: 'India has a well-established electrical manufacturing ecosystem, producing a wide range of electrical components and products for domestic and international markets. Taiga Sourcing connects international buyers with suitable Indian electrical manufacturers.',
    seo: {
      title: 'Electrical Products Sourcing from India | Taiga Sourcing',
      description: 'Source electrical components, switchgear, wiring accessories, panels and industrial electrical products from Indian manufacturers.',
      keywords: 'electrical sourcing India, switchgear India, electrical components India, wiring accessories India',
    },
  },
  'plumbing': {
    slug: 'plumbing',
    title: 'Plumbing Pipes & Fittings',
    shortDescription: 'Pipes, fittings, valves and plumbing solutions from India.',
    heroDescription: 'Source plumbing pipes, fittings, valves and plumbing solutions from Indian manufacturers for residential, commercial and industrial projects.',
    image: 'https://images.unsplash.com/photo-1620203853151-496c7228306c?auto=format&fit=crop&w=800&q=80',
    subcategories: [
      'PVC Pipes',
      'CPVC Pipes',
      'UPVC Pipes',
      'Pipe Fittings',
      'Valves',
      'Plumbing Accessories',
      'Industrial Piping',
    ],
    whatBuyersRequest: [
      'Specific pipe sizes, grades and pressure ratings',
      'ISI and international standard compliance',
      'Project-based bulk requirements',
      'Custom specifications and fittings',
      'Export packaging and documentation',
    ],
    overview: 'India is a major manufacturer of plumbing pipes and fittings, with production capabilities across PVC, CPVC, UPVC and metal piping solutions. Taiga Sourcing helps international buyers identify suitable Indian manufacturers for their plumbing and piping requirements.',
    seo: {
      title: 'Plumbing Pipes & Fittings Sourcing from India | Taiga Sourcing',
      description: 'Source PVC, CPVC, UPVC pipes, pipe fittings, valves and plumbing solutions from Indian manufacturers. Residential and industrial projects.',
      keywords: 'plumbing sourcing India, pipes India, pipe fittings India, valves India, PVC pipes India',
    },
  },
  chemicals: {
    slug: 'chemicals',
    title: 'Chemicals',
    shortDescription: 'Industrial, specialty and agro chemicals from Indian manufacturers.',
    heroDescription: 'Source industrial chemicals, specialty chemicals, dyes, pigments and agrochemicals from Indian manufacturers for industrial and commercial use.',
    image: 'https://images.unsplash.com/photo-1556216607-691819089c19?auto=format&fit=crop&w=800&q=80',
    subcategories: [
      'Industrial Chemicals',
      'Specialty Chemicals',
      'Dyes & Pigments',
      'Agrochemicals',
      'Construction Chemicals',
      'Chemical Intermediates',
    ],
    whatBuyersRequest: [
      'Specific grades, purity levels and technical specifications',
      'MSDS, COA and regulatory compliance documentation',
      'Bulk and drum/IBC packaging requirements',
      'Hazmat-compliant export documentation and labelling',
      'Consistent quality across repeat bulk orders',
    ],
    overview: 'India has a large and diverse chemical manufacturing base, producing industrial, specialty and agro chemicals for global markets. Taiga Sourcing helps international buyers identify suitable Indian chemical manufacturers and coordinates sourcing with attention to compliance, packaging and documentation requirements.',
    seo: {
      title: 'Chemicals Sourcing from India | Taiga Sourcing',
      description: 'Source industrial, specialty and agro chemicals, dyes and pigments from Indian manufacturers. Compliance documentation and bulk packaging.',
      keywords: 'chemical sourcing India, industrial chemicals India, specialty chemicals India, agrochemicals India',
    },
  },
  'custom-sourcing': {
    slug: 'custom-sourcing',
    title: 'Custom Sourcing',
    shortDescription: 'Products outside listed categories sourced based on your requirements.',
    heroDescription: 'Have a specific product requirement? We can help identify suitable Indian manufacturers across a wide range of product categories.',
    image: 'https://static.prod-images.emergentagent.com/jobs/d2ca7f8e-00c6-4430-9e4c-0d04d72e2047/images/89a2ea15ae4112109cbee192d80fe63ac260a01ded2a1c671f6680963a8fb034.jpeg',
    subcategories: [
      'Unlisted Product Categories',
      'Specialty Manufacturing',
      'Project-Based Sourcing',
      'Custom Product Development',
    ],
    whatBuyersRequest: [
      'Products not covered in standard categories',
      'Niche or specialty manufacturing',
      'Project-specific sourcing requirements',
      'New product development from concept',
      'Combination orders across multiple categories',
    ],
    overview: 'If your product requirement falls outside our listed categories, we can still help. Taiga Sourcing evaluates custom sourcing requests and works to identify suitable manufacturing options in India based on your specific needs.',
    seo: {
      title: 'Custom Product Sourcing from India | Taiga Sourcing',
      description: 'Custom product sourcing from India. We evaluate requirements and identify suitable Indian manufacturers for any product category.',
      keywords: 'custom sourcing India, product sourcing India, India sourcing agent, India procurement partner',
    },
  },
};

export const categoryList = Object.values(categoryData);

export const getCategoryBySlug = (slug) => categoryData[slug] || null;

export default categoryData;
